import { render, staticRenderFns } from "./tax-certificate-period-item-form.vue?vue&type=template&id=6e470208&scoped=true&"
import script from "./tax-certificate-period-item-form.vue?vue&type=script&lang=ts&"
export * from "./tax-certificate-period-item-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e470208",
  null
  
)

export default component.exports